export default {"src":"/_next/static/media/paypal.f6030e53.svg","height":24,"width":41,"blurWidth":0,"blurHeight":0};